<template>
  <div>  
    <div class="submenu">
      <ul>
        <router-link tag="li" to="/schemalaggningar">Visa alla schemaläggningar</router-link>
        <router-link tag="li" to="/schemalaggningar/ny">Skapa ny schemaläggning</router-link>
      </ul>
      <div class="clear"></div>
    </div>
        
    <div class="form">
      <div class="item">
        <div class="label">Namn</div>
        <div><input type="text" v-model="name" placeholder="Namn"></div>
      </div>
            
      <div class="item">
        <div class="label">Typ av schemaläggning</div>
        <div>
          <select v-model="triggerType">
            <option value="" disabled selected>Välj när här</option>
            <option value="time">Specifik tid</option>
            <option value="sunrise">Soluppgång ({{ getSunrise }})</option>
            <option value="sunset">Solnedgång ({{ getSunset }})</option>
          </select>
        </div>
        <div class="descr">Välj vilken typ av schemaläggning du vill lägga till. Vid en speciell tid, vid soluppgång eller vid solnedgång. Beroende på vilken typ du väljer får du fler alternativ här nedanför.</div>
      </div>
      
      <!-- Förskjutning vid soluppgång eller solnedgång -->
      <div class="item" v-if="triggerType.length && triggerType !== 'time'">
        <div class="label">Förskjutning / fördröjning</div>
        <div><input type="number" v-model.number="offsetMinutes" min="0" max="120"></div>
        <div class="descr">Detta gör det möjligt att köra din schemaläggning XX antal minuter före eller efter {{ triggerType == 'sunrise' ? 'soluppgången' : 'solnedgången' }}.</div>
      </div>
      
      <!-- Specifik tid -->
      <div class="item" v-if="triggerType.length && triggerType == 'time'">
        <div class="label">Tid</div>
        <div><input type="time" v-model="time"></div>
        <div class="descr">Detta är den tid din schemaläggning kommer att köras på under de dagarna du väljer här nedanför. Du kan skapa flertalet olika schemaläggningar om du vill använda olika tider.</div>
      </div>
            
      <!-- Vilka dagar -->
      <div class="item">
        <div class="label">Dagar</div>
        <div>
          <select v-model.number="days" multiple style="height:150px;">
            <option value="0">måndagar</option>
            <option value="1">tisdag</option>
            <option value="2">onsdag</option>
            <option value="3">torsdag</option>
            <option value="4">fredag</option>
            <option value="5">lördag</option>
            <option value="6">söndag</option>
          </select>
        </div>
        
        <div class="descr">Markera de dagarna du vill att schemaläggningen skall köras på. Du kan välja flera genom att hålla inne CTRL (Windows) eller CMD (OS X).</div>
      </div>
      
      <h3 style="margin-top:0px;">Kommandon</h3>
      
      <div class="item">
        <commands-view :commands="commands"></commands-view>
      </div>

      <hr class="space">  
      
      <h3 style="margin-top:0px;">Kör scenarion</h3>

      <div class="view">
        <table>
          <tbody>
            <tr v-for="scenario in scenarios">
              <td>{{ $root.data.scenarios.find(item => item.id === scenario).name }}</td>
            </tr>
          </tbody>
        </table>
        
        
        
        
        
        
      </div>

      <hr class="space">

      <div class="item">
        <button @click="save" :disabled="!ok"><span v-if="!saving">Spara schemaläggning</span><span v-else>Sparar...</span></button>
      </div>
      
      <div class="item delete" v-if="editing">
        <button @click="remove" class="red"><span v-if="!deleting">Radera schemaläggning</span><span v-else>Raderar...</span></button>
      </div>
    </div>    
  </div>
</template>

<script>
  import { HTTP } from '../http.js'
  import commandsView from './views/commandsView'

  export default {
    name: 'schemalaggningar_ny',
    components: {
      commandsView
    },
    data () {
      return {
        id: 0,
        name: '',
        triggerType: '',
        time: '',
        offsetMinutes: 0,
        days: [],
        commands: [],
        scenarios: [],
        test: '',
        saving: false,
        editing: false,
        deleting: false
      }
    },
    created () {
      this.editing = ('id' in this.$route.params)

      // Vi editerar en schemaläggning
      if (this.editing) {
        const json = this.$root.data.triggers.find(trigger => trigger.id === this.$route.params.id)

        this.id = json.id
        this.scenarios = json.scenarios || []
        this.name = json.name || 'Inget namn'
        this.triggerType = (json.triggerType === 'TimeTrigger' ? 'time' : json.sunType.toLowerCase())
        this.commands = json.scenario.commands || []
        this.offsetMinutes = json.offsetMinutes || 0

        // Vid specifik tid
        if (this.triggerType === 'time') {
          this.time = (json.time.hour < 10 ? '0' + json.time.hour : json.time.hour) + ':' + (json.time.minute < 10 ? '0' + json.time.minute : json.time.minute)

          for (let i = 0; i <= json.activeDays.length; i++) {
            // Om dag === true så används den
            if (json.activeDays[i] === true) {
              this.days.push(i)
            }
          }
        } else {
          // Vid antingen soluppgång eller solnedgång
          const days = json.condition['$is'].replace('globals.dayIs(', '').replace(')', '').trim()
          this.days = days.split(',')
        }
      }
    },
    methods: {
      save () {
        this.saving = true
        
        let path = 'triggers'
        if (this.editing) {
          path += '/' + this.$route.params.id
        }
        
        HTTP.post(path, this.payload)
        .then(res => res.data)
        .then(json => {
          this.saving = false
          
          if (this.editing) {
            const index = this.$root.data.triggers.findIndex(trigger => trigger.id === this.id)
            this.$root.data.triggers.splice(index, 1)
          }
          
          let obj = this.payload
          obj.id = json.id
          this.$root.data.triggers.push(obj)

          // Skicka vidare användaren till alla våra schemaläggningar
          this.$router.push({
            name: 'schemalaggningar'
          })
        })
      },

      remove () {
        if (confirm('Är du säker på att du vill radera schemaläggningen?')) {
          this.deleting = true
          
          // Radera från vår lista och därför vy
          const index = this.$root.data.triggers.findIndex(trigger => trigger.id === this.id)
          this.$root.data.triggers.splice(index, 1)
          
          this.$router.push({
            name: 'schemalaggningar'
          })
            
          HTTP.delete('triggers/' + this.id)
          .then(res => res.data)
          .then(json => {})
        }
      }
    },
    computed: {
      getSunrise () {
        return this.$root.data.info['sunrise']
      },

      getSunset () {
        return this.$root.data.info['sunset']
      },

      ok () {
        // Här validerar vi tiden, när det kommer till Safari och IE så
        // har inte dessa stöd för input time vilket betyder att användaren
        // egentligen kan skriva vad som helst. Därför måste vi validera
        // här.
        if (this.triggerType === 'time') {
          if (!this.time.length) {
            return false
          }

          if (this.time.includes(':')) {
            const [hour, minute] = this.time.split(':')
            if (hour && minute) {
              if (hour > 23 || minute > 59) {
                return false
              }
            } else {
              return false
            }
          } else {
            return false
          }
        }
        
        return this.name.length 
        && this.triggerType.length
        && this.days.length
        && this.commands.length
        && !this.saving
      },

      payload () {
        let array = []
        let i;
        for (i=0; i <= 6; i++) {
          array.push(this.days.includes(i) ? true : false)
        }

        let obj =  {
          name : this.name,
          triggerType: this.triggerType === 'time' ? 'TimeTrigger' : 'SunTrigger',
          scenario: {
            commands: this.commands
          },
          enabled: true,
          favorite: false
        }

        /*
          Beroende på om man har valt solnedgång/uppgång eller specifik tid
          så ska man använda olik payload när det kommer till vissa saker,
          ex. dagar som schemaläggningen skall vara aktiv på.
        */
        if (this.triggerType !== 'time') {
          obj.sunType = this.triggerType.toUpperCase()
          obj.offsetMinutes = this.offsetMinutes
          obj.condition = {
            '$is': 'globals.dayIs(' + this.days.join(',') + ')'
          }
        } else {
          if (this.time.length) {
            const [hour, minute] = this.time.split(':')

            obj.time = {
              hour: parseInt(hour),
              minute: parseInt(minute),
              second: 0,
              nano: 0
            }
          }

          obj.activeDays = array
        }
        
        return obj
      }
    }
  }
</script>

<style scoped>
  .delete {
    color: red !important;
  }
</style>


// WEBPACK FOOTER //
// src/components/schemalaggningar_ny.vue